<template>
  <v-app >
    <v-layout align-center justify-center class="bg" >
      <v-flex xs12 sm8 md6>

        <v-col   md="6">
        <v-card class="elevation-24 "   >
            <v-card-title>
           ورود به سیستم
            </v-card-title>
          <v-card-subtitle>
            همراه مجتمع8تا8 ویژه ساکنین
          </v-card-subtitle>


          <v-card-text>
            <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="Login">
              <v-text-field
                  label="نام کاربری"
                  outlined
                  dense
                  v-model="user.userName"
                  dir="ltr"
              />
              <v-text-field
                  v-model="user.password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  label="رمزعبور"
                  outlined
                  dense
                  dir="ltr"
                  @click:append="show1 = !show1"
              />



              <v-spacer/>

                <vue-captcha
                    width="200"
                    v-if="showCaptcha"
                    ref="captcha"
                    :captcha.sync="code"
                    @on-change="handleChange">
                </vue-captcha>
                <v-btn  v-if="showCaptcha" icon light @click="refresh"  color="primary">
                  <v-icon >mdi-cloud-refresh</v-icon>
                </v-btn>


              <v-flex>
                <v-text-field
                    v-if="showCaptcha"
                    label="کد"
                    placeholder="کد را وارد کنید..."
                    outlined
                    v-model="codeInUser"
                />

              </v-flex>
              <v-spacer/>


  <v-btn :loading="loading" block type="submit" dark color="primary">ورود</v-btn>






            </v-form>
          </v-card-text>
          <v-footer light  color="transparent">
            <v-col class="d-inline-flex">
            <v-list-item link dense @click="isforget=true">
             دریافت رمز جدید
            </v-list-item>
<!--              <v-btn  small  color="warning" class="mt-2" dense @click="hardRefresh">-->
<!--                بار گذاری مجدد-->
<!--              </v-btn>-->

            </v-col>
          </v-footer>
        </v-card>
        </v-col>

        <v-col  md="6">

        </v-col>

      </v-flex>
      <Forget :dialog-status.sync="isforget"/>
    </v-layout>
  </v-app>

</template>

<script>
import User from "../../models/user";
import Forget from "../define/profile/ForgetPass";
import VueCaptcha from 'vue-captcha-code';
export default {
  name: "Login",
  components:{
    Forget,
    VueCaptcha
  },
  data: () => {
    return {
      code: '',
      codeInUser:'',
      showCaptcha:false,
      loading: false,
      isforget: false,
      show1: false,
      time: '11:15',
      valid: true,
      user: new User('', '',''),
      counter: 0,


    }

  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {

  },
  methods: {
    hardRefresh() {
      window.location.reload(true)
    },
    handleChange(code) {
      this.code=code;
    },
    refresh() {
      this.$refs.captcha.refreshCaptcha();
    },

    Login() {

      if(this.counter>1){
        this.showCaptcha = true
        if(this.codeInUser!==this.code){
          this.$snack({type: 'error',message:'کد وارد شده صحیح نیست!!'})
          this.refresh()
          return;
        }
      }

          if (this.user.userName && this.user.password) {
            this.loading = true;
            this.isError = false;
            this.$store.dispatch('auth/login', this.user).then(
                () => {
                  if(this.$store.state.permissions===null){
                    this.$router.push('/profile')
                  }else {
                    // this.$window.location.reload()
                    this.$router.push('/home')
                  }

                }).catch(error => {
              this.loading = false;
              if (error && error.response && error.response.status === 401) {
                this.$snack({type: 'error',message:'نام کاربری یا کلمه عبور صحیح نمیباشد'})
                this.counter++

                this.refresh()
              }
            })

        }



  },
  }
}
</script>

<style scoped>
@import "../../assets/styles/global.css";
@import '../../../node_modules/vuetify/dist/vuetify.min.css';

.bg {
  background: url("../../assets/1.png") !important;
  background-size: cover!important;
  background-repeat: no-repeat!important;
  /*opacity: .2;*/
}




</style>